import Hero from '@components/Landing/Hero'
import Marquee from '@components/Landing/Marquee'
import FeaturedProducts from '@components/Landing/FeaturedProducts'
import About from '@components/Landing/About'
import Testimonials from '@components/Landing/Testimonials'
import Newsletter from '@components/Landing/Newsletter'

export default function LandingPage() {
  return (
    <>
      <Hero />
      <Marquee />
      <FeaturedProducts />
      <About />
      <Testimonials />
      <Newsletter />
    </>
  )
}
